/*
 * @Author: Michael
 * @Date: 2018-09-18 09:25:19
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-09-06 17:52:37
 */

interface Server {
  dev: string;
  dev1: string;
  rc: string;
  prod: string;
  gray?: string;
}

interface ServerB extends Server {}
interface AppId extends Server {}
interface ShareUrl extends Server {}
interface AppShowUrl extends Server {}
interface ShowUrl extends Server {}
interface appSuccessUrl extends Server {}

interface Config {
  server: Server;
  serverB: ServerB;
  serverC: ServerB;
  appId: AppId;
  localServerB: string;
  localServer: string;
  shareUrl: ShareUrl;
  appShowUrl: AppShowUrl;
  showUrl: ShowUrl;
  hybirdUrl: ShowUrl;
  cAppUrl: ShowUrl,
  templateMap: any;
  appSuccessUrl: appSuccessUrl;
}

const config: Config = {
  serverB: {
    dev: 'https://dev-heimdall.xiaomai5.com/',
    dev1: 'https://dev1-heimdall.xiaomai5.com/',
    rc: 'https://rc-heimdall.xiaomai5.com/',
    prod: 'https://heimdall.xiaomai5.com/',
    gray: 'https://gray-heimdall.xiaomai5.com/'
  },
  server: {
    dev: 'https://dev-heimdall.xiaomai5.com/',
    dev1: 'https://dev1-heimdall.xiaomai5.com/',
    rc: 'https://rc-heimdall.xiaomai5.com/',
    prod: 'https://heimdall.xiaomai5.com/',
    gray: 'https://gray-heimdall.xiaomai5.com/'
  },
  serverC: {
    dev: 'https://dev.xiaomai5.com/h5/index.html',
    dev1: 'https://dev.xiaomai5.com/h5/index.html',
    rc: 'https://rc.xiaomai5.com/h5/index.html',
    prod: 'https://res.xiaomai5.com/h5/index.html',
    gray: 'https://res.xiaomai5.com/h5/gray/index.html'
  },
  appId: {
    dev: 'wx3ea60e78ddfa277e',
    dev1: 'wx3ea60e78ddfa277e',
    rc: 'wx5c5a1fb71ecab7bc',
    prod: 'wxdd6b458500d4c224',
    gray: 'wxdd6b458500d4c224'
  },
  localServerB: 'https://heimdall.xiaomai5.com/',
  localServer: 'https://heimdall.xiaomai5.com/',
  shareUrl: {
    dev: 'https://dev.xiaomai5.com/share/show?appid=',
    dev1: 'https://dev1.xiaomai5.com/share/show?appid=',
    rc: 'https://rc.xiaomai5.com/share/show?appid=',
    prod: 'https://prod.xiaomai5.com/share/show?appid=',
    gray: 'https://prod.xiaomai5.com/share/show?appid='
  },
  appShowUrl: {
    dev: 'https://dev.xiaomai5.com/',
    dev1: 'https://dev1.xiaomai5.com/',
    rc: 'https://rc.xiaomai5.com/',
    prod: 'https://res.xiaomai5.com/',
    gray: 'https://res.xiaomai5.com/'
  },
  showUrl: {
    dev: 'https://dev.xiaomai5.com/xmshow/#/',
    dev1: 'https://dev1.xiaomai5.com/xmshow/#/',
    rc: 'https://rc.xiaomai5.com/xmshow/#/',
    prod: 'https://res.xiaomai5.com/xmshow/index.html#/',
    gray: 'https://res.xiaomai5.com/xmshow/gray/index.html#/'
  },
  cAppUrl: {
    dev: 'https://dev.xiaomai5.com/h5/index.html#/',
    dev1: 'https://dev1.xiaomai5.com/h5/index.html#/',
    rc: 'https://rc.xiaomai5.com/h5/index.html#/',
    prod: 'https://res.xiaomai5.com/h5/index.html#/',
    gray: 'https://res.xiaomai5.com/h5/gray/index.html#/'
  },
  appSuccessUrl: {
    dev: 'http://dev-web-server.xiaomai5.com/ssr/show/index?page=mine',
    dev1: 'http://dev1-web-server.xiaomai5.com/ssr/show/index?page=mine',
    rc: 'https://rc-web-server.xiaomai5.com/ssr/show/index?page=mine',
    prod: 'https://web-server.xiaomai5.com/ssr/show/index?page=mine',
    gray: 'https://canary-web-server.xiaomai5.com/ssr/show/index?page=mine'
  },
  hybirdUrl: {
    dev: 'https://dev.xiaomai5.com/hybird/index.html#',
    dev1: 'https://dev1.xiaomai5.com/hybird/index.html#',
    rc: 'https://rc.xiaomai5.com/hybird/index.html#',
    gray: 'https://res.xiaomai5.com/hybird/gray/index.html#',
    prod: 'https://res.xiaomai5.com/hybird/index.html#'
  },
  templateMap: {
    bargainType: '砍价',
    bargainGroupType: '团购砍价',
    groupType: '团购',
    rollType: '抽奖',
    tyType: '集赞',
    voteType: '投票',
    lessonType: '微传单',
    redPackageType: '微游戏',
    gachaType: '扭蛋机',
    distributeType: '分销'
  }
};

export default config;
